var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDigiWallet128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17016)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4291 16.4011H42.0169C37.5893 16.4011 34 19.9904 34 24.418V104.587C34 109.015 37.5893 112.604 42.0169 112.604H79.4291C83.8567 112.604 87.4459 109.015 87.4459 104.587V24.418C87.4459 19.9904 83.8567 16.4011 79.4291 16.4011Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4291 16.4011H42.0169C37.5893 16.4011 34 19.9904 34 24.418V104.587C34 109.015 37.5893 112.604 42.0169 112.604H79.4291C83.8567 112.604 87.4459 109.015 87.4459 104.587V24.418C87.4459 19.9904 83.8567 16.4011 79.4291 16.4011Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 98.8606H87.4459V104.587C87.4459 109.015 83.8567 112.604 79.4291 112.604H42.0169C37.5893 112.604 34 109.015 34 104.587V98.8606Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7229 109.168C62.648 109.168 64.2085 107.629 64.2085 105.732C64.2085 103.834 62.648 102.296 60.7229 102.296C58.7979 102.296 57.2373 103.834 57.2373 105.732C57.2373 107.629 58.7979 109.168 60.7229 109.168Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.751 23.2732H70.0171",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_17016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 46,
    width: 21,
    height: 35
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.308 46.7595L93.4616 59.9214V67.1134L110.308 80.2753L113.497 77.8356V49.4318L110.308 46.7595Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_17016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.167 44.8113C109.621 48.9682 111.848 55.2035 111.848 63.5174C111.848 71.8312 109.621 78.0665 105.167 82.2234",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1503 50.156C101.604 53.1252 103.831 57.5791 103.831 63.5175C103.831 69.4559 101.604 73.9098 97.1503 76.879",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3103 58.1731C95.4237 59.3608 95.9805 61.1423 95.9805 63.5177C95.9805 65.8931 95.4237 67.6746 94.3103 68.8623",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDigiWallet128);
export default __webpack_public_path__ + "static/media/pictogramBeaconDigiWallet128.d988c5c6fd48a234050f377d88e2668d.svg";
export { ForwardRef as ReactComponent };